import { ref } from '@vue/composition-api'

export default function useChartZoom({ charts, sliderValue, zoomedSliderValueFor }) {
  const isZoomIn = ref(false)
  const sliderValueBeforeZoom = ref(sliderValue.value)

  const zoomIn = chartId => {
    isZoomIn.value = true
    sliderValueBeforeZoom.value = sliderValue.value
    charts.forEach((chart, idx) => {
      if (chart) {
        if (chartId !== idx) chart.applyOptions({ height: 1 })
        else chart.applyOptions({ timeScale: { visible: true } })
      }
    })
    sliderValue.value = zoomedSliderValueFor(chartId)
  }

  const zoomOut = () => {
    isZoomIn.value = false
    sliderValue.value = sliderValueBeforeZoom.value
    const lastIdx = charts.length - 1
    charts.forEach((chart, idx) => {
      if (chart) chart.applyOptions({ timeScale: { visible: idx === lastIdx } })
    })
  }

  return { isZoomIn, zoomIn, zoomOut }
}
